<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>查看评估报告</span>
    </div>
    <div class="pgbg" v-loading="loading">
      <div class="deviceInfo-header">
        <div>{{flag==2?'课程信息':'基本信息'}}</div>
        <div>
          <el-button type="primary" @click="goBack">返回</el-button>
        </div>
      </div>
      <div v-if="flag!=2" class="pgbg-conts" style="padding: 20px;">
        <table class="boughtTable">
          <tr>
            <td class="boughtTd1">标题</td>
            <td colspan="5">{{planInfo.planname}}</td>
          </tr>
          <tr>
            <td class="boughtTd1">培训部门</td>
            <td colspan="3">{{planInfo.orgName}}</td>
            <td class="boughtTd1">培训类别</td>
            <td>{{planInfo.ontypeName}}</td>
          </tr>
          <tr>
            <td class="boughtTd1">培训方式</td>
            <td>{{planInfo.itype==1?'线上培训':'线下培训'}}</td>
            <td class="boughtTd1">课时</td>
            <td>{{planInfo.littletime}}</td>
            <td class="boughtTd1">培训人数</td>
            <td>{{planInfo.pnum}}</td>
          </tr>
          <tr>
            <td class="boughtTd1">有效期</td>
            <td colspan="5">{{planInfo.endtime}}</td>
          </tr>
          <tr>
            <td class="boughtTd1">培训结论</td>
            <td colspan="5">
              <div v-html="jielun" style="padding-bottom: 5px;">
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="flag==2" class="pgbg-conts disFlex" style="padding: 20px;">
        <div>
          <el-image style="width: 169px; height: 113px;border-radius: 4px;" :src="wjSrc+productInfo.img"></el-image>
        </div>
        <div style="margin-left: 20px;">
          <table class="boughtTable">
            <tr>
              <td class="boughtTd1">标题</td>
              <td colspan="5">{{productInfo.cname}}
               <!-- <el-link v-if="productInfo.producttype=='2'" type="primary" @click="toMx" :underline="true"
                  style="margin-left: 10px;line-height: 17px;">明细</el-link> -->
              </td>
            </tr>
            <tr>
              <td class="boughtTd1">培训类目</td>
              <td>{{productInfo.ontypeName}}</td>
              <td class="boughtTd1">课时</td>
              <td>{{productInfo.ksyq}}</td>
              <td class="boughtTd1">价格</td>
              <td>{{flag=='2'?'-/-':'￥'+(productInfo.price*productInfo.dnbuyamount)}}</td>
            </tr>
            <tr>
              <td class="boughtTd1">购买数量</td>
              <td>{{flag=='2'?'-/-':productInfo.dnbuyamount}}</td>
              <td class="boughtTd1">报名人数</td>
              <td>{{productInfo.appUsers?productInfo.appUsers.length:0}}</td>
              <td class="boughtTd1">有效期</td>
              <td>{{productInfo.endtime?productInfo.endtime.substring(0,10):''}}</td>
            </tr>
            <tr>
              <td class="boughtTd1">学习结论</td>
              <td colspan="5">
                <div v-html="jielun" style="padding-bottom: 5px;">
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>


      <div class="deviceInfo-header">
        <div>效果评估</div>
      </div>
      <div class="">
        <el-row :gutter="20">
          <el-col :span="12">
            <div id="echarts1" class="pgbgEcharts"></div>
          </el-col>
          <el-col :span="12">
            <div id="echarts2" class="pgbgEcharts"></div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div id="echarts3" class="pgbgEcharts"></div>
          </el-col>
          <el-col :span="12">
            <div id="echarts4" class="pgbgEcharts"></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts';
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      return {
        options: [],
        productInfo: {},
        planInfo: {},
        loading: false,
        jielun: '',
        flag:1
      }
    },
    methods: {
      goBack: function() {
        this.$router.go(-1);
      },
      // 培训合格率
      initChartsBie(item, chratsid) {
        var hgl = parseInt((item.passNum / item.pnum) * 100)
        var option = {
          title: [{
              text: item.itypeName
            },
            {
              text: hgl + '%',
              x: 'center',
              y: '45%',
              textStyle: {
                fontSize: '30',
                fontFamily: 'DINAlternate-Bold, DINAlternate',
                foontWeight: '600',
              },
            },
          ],
          polar: {
            radius: ['42%', '52%'],
            center: ['50%', '50%'],
          },
          angleAxis: {
            max: 100,
            show: false,
          },
          radiusAxis: {
            type: 'category',
            show: true,
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
          series: [{
              name: '',
              type: 'bar',
              roundCap: true,
              barWidth: 30,
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(66, 66, 66, .3)',
              },
              data: [hgl],
              coordinateSystem: 'polar',
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: '#16CEB9',
                    },
                    {
                      offset: 1,
                      color: '#6648FF',
                    },
                  ]),
                },
              },
            },
            {
              name: '',
              type: 'pie',
              startAngle: 80,
              radius: ['56%'],
              hoverAnimation: false,
              center: ['50%', '50%'],
              itemStyle: {
                color: 'rgba(66, 66, 66, .1)',
                borderWidth: 1,
                borderColor: '#5269EE',
              },
              data: [100],
            },
            {
              name: '',
              type: 'pie',
              startAngle: 80,
              radius: ['38%'],
              hoverAnimation: false,
              center: ['50%', '50%'],
              itemStyle: {
                color: 'rgba(66, 66, 66, .1)',
                borderWidth: 1,
                borderColor: '#5269EE',
              },
              data: [100],
            },
          ],
        };
        var myChart = echarts.init(document.getElementById(chratsid));
        myChart.setOption(option);
      },
      initCharts(item, chratsid) {
        var arr = [
          [item.itypeName, '满意', '一般', '不满意']
        ];
        item.items.map((child) => {
          arr.push([child.itemName, child.v1 || 0, child.v2 || 0, child.v3 || 0]);
        });
        var option = {
          title: {
            text: item.itypeName
          },
          legend: {},
          tooltip: {
            valueFormatter: function(value) {
              return value + '人'
            }
          },
          dataset: {
            source: arr
          },
          xAxis: {
            type: 'category'
          },
          calculable: true,
          yAxis: {
            type: 'value',
            minInterval: 1, //只显示整数
            axisLabel: {
              formatter: '{value} 人'
            }
          },
          // Declare several bar series, each will be mapped
          // to a column of dataset.source by default.
          series: [{
            type: 'bar',
            barWidth: 25
          }, {
            type: 'bar',
            barWidth: 25
          }, {
            type: 'bar',
            barWidth: 25
          }]
        };

        var myChart = echarts.init(document.getElementById(chratsid));
        myChart.setOption(option);
      },
      getData: function(id) {
        this.$axios.get('/kt/ktProductLeanplan/detail.htm?id=' + id).then(res => {
          var data = res.data;
          this.loading = false;
          if (data) {
            this.planInfo = data.data;
          } else {
            this.$message.error(data.message);
          }
        });
      },
      getDetail: function(id) {
        this.$axios.get('/kt/wz/productInfo/getProdcutallDetail.htm?id=' + id).then(res => {
          var data = res.data;
          this.loading = false;
          if (data) {
            this.productInfo = data.data;
          } else {
            this.$message.error(data.message);
          }
        });
      },
      getDataList: function(id) {
        this.$axios.get('/kt/ktAppraiseUser/getlistByDataId.htm?dataId=' + id).then(res => {
          var data = res.data;
          this.loading = false;
          if (data) {
            data.map((item, i) => {
              if (i == 0) {
                this.jielun = item.jielun;
              }
              if (item.itype == 'ZXKT_appraisal_itype_2') {
                this.initChartsBie(item, 'echarts' + (i + 1));
              } else {
                this.initCharts(item, 'echarts' + (i + 1));
              }
            })
          } else {
            this.$message.error(data.message);
          }
        });
      }
    },
    created: function() {
      if (this.$route.query.flag && this.$route.query.flag == 2) {
        // 产品详情
        this.getDetail(this.$route.query.id);
        this.flag=2;
      } else {
        // 计划详情
        this.getData(this.$route.query.id);
      }
      this.getDataList(this.$route.query.id);

      // 滚动条滚动到最顶部
      $('#app').animate({
        scrollTop: 110
      }, 300);
    },
    components: {}
  }
</script>
<style>
  .deviceInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .deviceInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
  }

  .deviceInfo-content {
    padding: 20px;
  }

  .boughtTable {
    line-height: 38px;
    text-align: left;
    font-size: 14px;
  }

  .boughtTable td {
    padding-left: 20px;
    width: 140px;
    border: 1px solid #efefef;
  }

  .boughtTd1 {
    height: 38px;
    background-color: #f6f6f6;
    width: 105px;
  }

  .likeSatrt {
    height: 6px;
    opacity: 1;
    background: #f5f5f5;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .pgbg {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .pgbg-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    display: flex;
    align-items: center;
    font-size: 16px;
  }

  .avatar {
    width: 100px;
    height: 140px;
  }

  .sjsc .el-input-number .el-input__inner {
    text-align: left;
  }

  .el-tree-node__content {
    height: 32px;
  }

  .pgbgEcharts {
    height: 300px;
    padding: 20px;

  }
</style>



// WEBPACK FOOTER //
// src/components/company/Pxbaogao.vue